export const _SUCCESS = "_SUCCESS";
export const _FAILURE = "_FAILURE";

export const getSuccessActionType = <T extends string>(type: T) => `${type}${_SUCCESS}` as const;
export const getFailureActionType = <T extends string>(type: T) => `${type}${_FAILURE}` as const;
